'use client';

export { default } from './usePagination';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/usePagination/index.js
// module id = 499
// module chunks = 22